<template>
  <div class="main">
    <div class="sidebar">
      <Sidebar></Sidebar>
    </div>
    <div class="content">
      <h3>{{ contact_us.title }}</h3>
      <div v-html="contact_us.content"></div>
    </div>
  </div>
</template>
<script>
import Sidebar from "./ContactSidebar.vue";

export default {
  data() {
    return {
      contact_us: "",
    };
  },
  created: function () {
    this.get_contact_us();
  },
  methods: {
    get_contact_us() {
      let url = "contact";
      this.$http.get(url).then((response) => {
        this.contact_us = response.data[0];
      });
    },
  },
  components: {
    Sidebar: Sidebar,
  },
};
</script>
<style lang="scss" scoped>
</style>
